'use client';

import { useCallback, useState } from 'react';
import dynamic from 'next/dynamic';
import { Button } from 'shared/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from 'shared/ui/dialog';
import type { IServiceSelect } from 'widgets/project-creation-stepper/model';
import type { IStepper } from 'widgets/project-creation-stepper/providers/stepper-provider';
import * as m from '@paraglide/messages';
const ProjectCreationStepper = dynamic(() => import('./project-creation-stepper').then(m => m.ProjectCreationStepper));
export interface CreateProjectButtonProps {
  text: string;
  icon?: React.ReactNode;
  serviceType?: IServiceSelect['name'];
  projectType?: string;
  marketplaceType?: string;
  stepper?: IStepper;
  className?: string;
}
export const CreateProjectButton = ({
  text,
  icon,
  serviceType,
  projectType,
  marketplaceType,
  stepper,
  className
}: CreateProjectButtonProps) => {
  const [open, setOpen] = useState(false);
  const handleClose = useCallback(() => setOpen(false), []);
  return <Dialog open={open} onOpenChange={setOpen} data-sentry-element="Dialog" data-sentry-component="CreateProjectButton" data-sentry-source-file="create-project-button.tsx">
      <DialogTrigger asChild data-sentry-element="DialogTrigger" data-sentry-source-file="create-project-button.tsx">
        <Button size="sm" className={className} data-sentry-element="Button" data-sentry-source-file="create-project-button.tsx">
          {icon && icon}
          {text}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-3xl py-8 px-5 pb-6 max-h-[90dvh]" data-sentry-element="DialogContent" data-sentry-source-file="create-project-button.tsx">
        <DialogHeader className="px-3" data-sentry-element="DialogHeader" data-sentry-source-file="create-project-button.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="create-project-button.tsx">{m.create_dialog_step_title()}</DialogTitle>
        </DialogHeader>

        {open && <ProjectCreationStepper handleClose={handleClose} serviceType={serviceType} projectType={projectType} marketplaceType={marketplaceType} stepper={stepper} />}
      </DialogContent>
    </Dialog>;
};